<template>
  <div class="interactive-html">
    <header-box :title="title"></header-box>
    <div class="interactive-html__innerwrap">
      <transition name="fade">
        <div v-if="fullscreen" class="interactive-html__overlay">
          <div class="interactive-html__overlay-header">
            <header-box :no-margin="true" :long="true" :title="title"></header-box>
            <a href="#" class="interactive-html__overlay-close" @click="toggleFullscreen"></a>
          </div>
          <iframe class="interactive-html__iframe no-swipe-nav" :src="htmlUrl"></iframe>
        </div>
      </transition>
      <div class="interactive-html__blocks">
        <div class="interactive-html__block">
          <div class="interactive-html__block-textwrap">
            <h2 class="interactive-html__block-title" v-html="linkBlockTitle"></h2>
            <div class="interactive-html__block-content" v-html="linkBlockContent"></div>
            <a class="interactive-html__cta" href="#" @click="toggleFullscreen">{{linkBlockCta}}</a>
          </div>

          <div class="interactive-html__block-image">
            <img :src="linkBlockImage" />
          </div>
        </div>

        <div class="interactive-html__block" v-for="block in contentBlocks">

          <div class="interactive-html__block-image" v-if="(block.imagePosition === 'left')">
            <movie-player v-if="block.video" class="interactive-html__block-video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
            <img v-if="!block.video" :src="block.image" />
          </div>

          <div class="interactive-html__block-textwrap">
            <h2 class="interactive-html__block-title" v-html="block.title"></h2>
            <div class="interactive-html__block-content" v-html="block.content"></div>
          </div>

          <div class="interactive-html__block-image" v-if="(block.imagePosition === 'right')">
            <movie-player v-if="block.video" class="interactive-html__block-video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
            <img v-if="!block.video" :src="block.image" />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';
import HeaderBox from '@/components/HeaderBox';
import MoviePlayer from '@/components/MoviePlayer';

export default {
  name: 'interactive-html',
  components: { PrevNextNav, HeaderBox, MoviePlayer },
  data() {
    return {
      fullscreen: false,
    };
  },
  mounted() {
    const iframeLinks = this.$el.querySelectorAll('.interactive-html__content a');
    [].forEach.call(iframeLinks, (iframeLink) => {
      iframeLink.addEventListener('click', this.toggleFullscreen);
    });
  },
  computed: {
    ...mapGetters(['page']),
    title() {
      return this.page.title;
    },
    linkBlockTitle() {
      return this.page.linkBlockTitle;
    },
    linkBlockContent() {
      return this.page.linkBlockContent;
    },
    linkBlockCta() {
      return this.page.linkBlockCta;
    },
    linkBlockImage() {
      return this.page.linkBlockImage;
    },
    htmlUrl() {
      return this.page.htmlUrl;
    },
    contentBlocks() {
      return this.page.contentBlocks;
    },
  },
  methods: {
    toggleFullscreen(ev) {
      ev.preventDefault();
      this.fullscreen = !this.fullscreen;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.interactive-html {
  @include page;

  .fade-enter-active, .fade-leave-active {
    transition: opacity .35s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  &__innerwrap {
    padding-top: 0;
  }

  &__overlay {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 70px;
    background: $c_white;
    z-index: 3;
    // transition: opacity .35s;

    // &.hide {
    //   opacity: 0;
    //   pointer-events: none;
    // }
  }

  &__overlay-header {
    position: relative;
  }

  &__overlay-close {
    display: block;
    height: 46px;
    width: 46px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../../../static/svg/icon_minimize-white.svg');
    position: absolute;
    top: calc(50% - 23px);
    right: 20px;
    transition: opacity .3s;
    z-index: 3;
    outline: none;
  }

  &__iframe {
    display: block;
    flex-grow: 1;
    width: 100%;
    border: none;
    outline: none;
  }

  &__cta {
    display: block;
    @include font-block-subtitle;
    margin: 0;
    color: $c_primary;
    text-decoration: none;
    font-style: normal;
    margin-top: 50px;

    &::after {
      content: '';
      display: inline-block;
      width: 17px;
      height: 13px;
      margin: 5px 10px;
      vertical-align: top;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('../../../static/svg/icon_cta.svg');
      transition: transform .35s;
    }

    &:hover::after {
      transform: translateX(6px);
    }
  }

  // &__content {
  //   @include font-block-content;

  //   box-sizing: border-box;
  //   padding: 30px 30px;
  //   margin: auto;

  //   p:first-child {
  //     margin-top: 0;
  //   }

  //   @include not-mobile {
  //     padding: 40px 0;
  //     width: 83.33%;
  //     margin: 0 30px;
  //     // margin-left: 16.66%;
  //   }

  //   @include landscape {
  //     order: unset;
  //     margin: 20px 0;
  //     width: 75%;
  //     padding: 20px 0 20px 20px;
  //   }

  //   @include not-tablet {
  //     margin: 30px 0;
  //     width: 75%;
  //     max-width: 750px;
  //     padding: 0 0 0 30px;

  //     @include desktop {
  //       width: 66.66%;
  //     }
  //   }
  // }

  &__blocks {
    box-sizing: border-box;
    // padding: 40px;
    margin-top: 20px;
    @include not-mobile {
      margin-top: 40px;
    }
  }

  &__block {
    box-sizing: border-box;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;

    @include not-mobile {
      flex-direction: row;
      padding-bottom: 40px;
    }

    @include tablet {
      display: block;
    }

    @include landscape {
      display: flex;
      flex-direction: row;
      padding-bottom: 20px;
    }
  }

  &__block-image {
    display: block;
    position: relative;
    overflow: hidden;

    @include tablet {
      width: calc(66.66% - 10px);
    }

    @include landscape {
      width: 50%;
    }

    @include not-tablet {
      width: 50%;
    }

    img {
      display: block;
      width: 100%;
    }

    // video + img {
    //   transition: opacity .5s;
    // }

    // video:not(.hide) + img {
    //   opacity: 0;
    // }
  }

  // &__block-video {
  //   width: 100%;
  //   display: block;
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   transition: opacity .5s;

  //   &.hide {
  //     opacity: 0;
  //     pointer-events: none;
  //   }
  // }

  &__block-textwrap + &__block-image {
    @include tablet {
      margin-left: calc(33.33% + 10px);
    }

    @include landscape {
      margin: 0;
    }
  }

  &__block-textwrap {
    box-sizing: border-box;
    background: $c_white;
    padding: 35px 30px;

    @include mobile {
      order: 1;
    }

    @include tablet {
      width: calc(66.66% - 10px);
      margin-bottom: -40px;
      padding: 40px 40px 80px;
    }

    @include landscape {
      order: unset;
      width: 50%;
      padding: 35px 30px;
      margin: 0;
    }

    @include not-tablet {
      width: 50%;
      padding: 40px;
    }

    @include desktop {
      width: 33.33%;
      margin-left: 16.665%;
    }
  }

  &__block-image + &__block-textwrap {
    @include tablet {
      margin-left: calc(33.33% + 10px);
      margin-top: -40px;
      margin-bottom: 0;
      padding: 80px 40px 40px;
    }

    @include landscape {
      margin: 0;
      padding: 35px 30px;
    }

    @include not-tablet {
      margin-left: 0;
    }
  }

  &__block-title {
    @include font-block-title;
  }

  &__block-content {
    @include font-block-content;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/templates/InteractiveHtml.vue